import { FormFieldWidth } from "./FormField.Types";

export function getFormFieldWidthClass(width: FormFieldWidth): string | undefined {
  switch (width) {
    case FormFieldWidth.FULL:
      return "w-full";
    case FormFieldWidth.CUSTOM:
      return undefined;
    default:
      return "w-[240px] max-w-full";
  }
}
